var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile page-background"},[_c('fp-table-list',{staticClass:"questionnaires-to-patient-table",attrs:{"bordered":true,"hasInputFilter":true,"hasDateFilter":true,"dateFilterStartDate":"Date","dateFilterEndDate":"Date","inputFilterKeyList":[
        'Type',
        'Parameter',
        'User',
        'Result'
    ],"items":_vm.processListItems,"fields":_vm.processListFields}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }